import React, { Component } from 'react'
import Card from '../Card'
import injectSheet from 'react-jss'
import { Link } from 'react-router-dom'
import { formStyle } from '../../../Theme/Theme'
import { apiUrl } from '../../../Utility'
import Responsive from 'react-responsive'
// import ReactGA from 'react-ga'
import {HotKeys} from 'react-hotkeys';
import TagManager from 'react-gtm-module'


const Desktop = props => <Responsive {...props} minWidth={1025} />
const Mobile = props => <Responsive {...props} maxWidth={1024} />

class UserInfoForm extends Component {
    constructor (props) {
        super(props)
        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            confirmPassword: '',
            errorMsg: '',
            valid: false
        }
    }

    render() {
        const { classes } = this.props
        const { Header, HeaderMobile, Body, BodyMobile, Footer, NextButton, Disabled, WrongMenuText, ErrorText } = classes

        const map = {
            next: 'enter'
          };
      
        const handlers = {
          next: this.submit
        }

        return (
            <Card>
                <HotKeys keyMap={map} handlers={handlers}>
                    <Desktop>
                        <div className={Header}>
                            <h1>Sign Up</h1>
                            {this.state.errorMsg ? <span className={ErrorText}><i className="fas fa-exclamation-triangle" style={{marginRight: '.5rem'}}/>{this.state.errorMsg}</span> : <span className={ErrorText}/>}
                        </div>
                        <div className={Body}>
                            <input type="text" name='firstName' placeholder='First Name' value={this.state.firstName} onChange={this.onChange} />
                            <input type="text" name='lastName' placeholder='Last Name' value={this.state.lastName} onChange={this.onChange} />
                            <input type="email" name='email' placeholder='Email' value={this.state.email} onChange={this.onChange} />
                            <input type="password" name='password' placeholder='Password' value={this.state.password} onChange={this.onChange} />
                            <input type="password" name='confirmPassword' placeholder='Confirm Password' value={this.state.confirmPassword} onChange={this.onChange} />
                        </div>
                        <div className={Footer}>
                            <button className={this.state.valid ? NextButton : Disabled} onClick={this.submit}>NEXT</button>
                            <span className={WrongMenuText}>Already a member? <Link to='/welcome/signin'>Sign In</Link></span>
                        </div>
                    </Desktop>
                    <Mobile>
                        <div className={HeaderMobile}>
                            <h1>Sign Up</h1>
                            {this.state.errorMsg ? <span className={ErrorText}><i className="fas fa-exclamation-triangle" style={{marginRight: '.5rem'}}/>{this.state.errorMsg}</span> : <span className={ErrorText}/>}
                        </div>
                        <div className={BodyMobile}>
                            <input type="text" name='firstName' placeholder='First Name' value={this.state.firstName} onChange={this.onChange} />
                            <input type="text" name='lastName' placeholder='Last Name' value={this.state.lastName} onChange={this.onChange} />
                            <input type="email" name='email' placeholder='Email' value={this.state.email} onChange={this.onChange} />
                            <input type="password" name='password' placeholder='Password' value={this.state.password} onChange={this.onChange} />
                            <input type="password" name='confirmPassword' placeholder='Confirm Password' value={this.state.confirmPassword} onChange={this.onChange} />
                        </div>
                        <div className={Footer}>
                            <button className={this.state.valid ? NextButton : Disabled} onClick={this.submit}>NEXT</button>
                            <span className={WrongMenuText}>Already a member? <Link to='/welcome/signin'>Sign In</Link></span>
                        </div>
                    </Mobile>
                </HotKeys>
            </Card>
        )
    }

    componentDidMount () {
        // ReactGA.pageview('/welcome/signup/userInfo');
        TagManager.dataLayer({
            dataLayer: {
                event: 'PageView',
                page: '/welcome/signup/userInfo',
            }
          })
    }    

    onChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        let { firstName, lastName, email, password, confirmPassword } = this.state
        const newState = {
          [name]: value,
          errorMsg: '',
          valid: false
        }
    
        switch (name) {
            case 'firstName':
                firstName = value
                break
            case 'lastName':
                lastName = value
                break
            case 'email':
                email = value
                break
            case 'password':
                password = value
                break
            case 'confirmPassword':
                confirmPassword = value
                break
            default:
                break
        }
    
        const firstNameIsFilled = firstName.length > 0
        const lastNameIsFilled = lastName.length > 0
        const emailIsFilled = email.length > 0
        const passwordIsFilled = password.length > 0
        const confirmPasswordIsFilled = confirmPassword.length > 0
    
        const isFilled = firstNameIsFilled && lastNameIsFilled && emailIsFilled && passwordIsFilled && confirmPasswordIsFilled
    
        if (isFilled) {
          newState.valid = true
    
          // Check email is valid
          if (!email.includes('@') || !email.includes('.')) {
            newState.errorMsg = `Valid email is required`
            newState.valid = false
          }
    
          // Check that passwords match
          if (confirmPassword !== password) {
            newState.errorMsg = `Passwords don't match`
            newState.valid = false
          }
        }
    
        this.setState(newState)
    }

    submit = (e) => {
        const { firstName, lastName, email, password, valid } = this.state
        if (!valid) {
          return
        } else {
            fetch(`https://${apiUrl}/api/v1/email_check?email=${email}`, { method: 'POST' })
                .then(response => {
                    response.json().then(data => {
                        console.log(data)
                        if (data.emailExists === 'false') {
                            this.props.onSubmit(firstName, lastName, email, password)
                            this.props.history.push('/welcome/signup/choosePlan')
                        } else {
                            this.setState({
                                errorMsg: 'An account exists for that email'
                            })
                        }
                    })
                })
        }
    }
}

const styles = {
    ...formStyle
}

export default injectSheet(styles)(UserInfoForm)


// WEBPACK FOOTER //
// ./src/js/Components/LandingPage/SignupComponents/UserInfoForm.jsx